import { ApiClient } from './client';
import type { Upload } from '@/app/types/uploads';

export interface UploadsResponse {
  uploads: Upload[];
}

export class UploadsClient extends ApiClient {
  async upload(projectId: number, takeoffId: number, file: File): Promise<Upload> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await this._post<Upload>(
      `/projects/${projectId}/takeoffs/${takeoffId}/upload`,
      {
        body: formData,
      },
    );

    return response;
  }

  async list(projectId: number, takeoffId: number): Promise<UploadsResponse> {
    const response = await this._get<UploadsResponse>(
      `/projects/${projectId}/takeoffs/${takeoffId}/upload`,
    );

    return response;
  }
}
